import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService, UsersService} from "../../../services";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {ValidationService} from "../../../services/validation.service";
import {AlertService} from "../../../helpers/alert/alert.service";
import {NavigationService} from "../../../services/navigation/navigation.service";
import {ENVIRONMENT} from "../../../../environments/environment";
import {HelperService} from "../../../services/helperService";


@Component({
	selector: "tig-authentication",
	templateUrl: "auth.component.html"
})
export class AuthComponent implements OnInit
{


	/**
	 * Attributes
	 */
	OBJ_model: any = {};
	BOO_loading = false;
	STR_company: string;
	OBJ_form_group: FormGroup;


	/**
	 * Function > constructor
	 * @param {Router} OBJ_router
	 * @param {AuthService} OBJ_auth_service
	 * @param {AlertService} OBJ_alert_service
	 * @param {FormBuilder} OBJ_form_builder
	 * @param {TranslateService} OBJ_translate_service
	 * @param {UsersService} OBJ_user_service
	 * @param {ValidationService} OBJ_validation_service
	 * @param {NavigationService} OBJ_navigation_service
	 * @param {ActivatedRoute} OBJ_activate_route
	 * @param {HelperService} OBJ_helper_service
	 */
	constructor
	(
		private OBJ_router: Router,
		private OBJ_auth_service: AuthService,
		private OBJ_alert_service: AlertService,
		private OBJ_form_builder: FormBuilder,
		private OBJ_translate_service: TranslateService,
		private OBJ_user_service: UsersService,
		private OBJ_validation_service: ValidationService,
		private OBJ_navigation_service: NavigationService,
		private OBJ_activate_route: ActivatedRoute,
		private OBJ_helper_service: HelperService
	)
	{

		this.OBJ_form_group = OBJ_form_builder.group({
			username: ["", [Validators.required, ValidationService.checkEmail]],
			password: ["", [Validators.required, Validators.minLength(2)]]
		});

        // get company string
        let OBJ_config = OBJ_helper_service.getFromLocalstorage('config');
        this.STR_company = OBJ_config.company;

	} // end function constructor


	/**
	 * Function > ngOnInit
	 * @return {void}
	 */
	ngOnInit(): void
	{

		// console log
		this.OBJ_helper_service.log
		(
			{class: 'AuthComponent', function: 'ngOnInit'},
			"autologin: " + this.OBJ_activate_route.snapshot.data.BOO_autologin,
			this.OBJ_activate_route.snapshot
		);

		if (this.OBJ_activate_route.snapshot.data.BOO_autologin)
		{
			// go to start page
			this.OBJ_router.navigate(["/starter"]);
		}
		else
		{
			// reset login status
			this.OBJ_auth_service.logout();

			// Show error if set
			if(this.OBJ_activate_route.snapshot.paramMap.get("STR_error") && (typeof this.OBJ_activate_route.snapshot.paramMap.get("STR_error") === 'string'))
			{
				// output error via alert service
				this.OBJ_alert_service.error(this.OBJ_translate_service.instant(this.OBJ_activate_route.snapshot.paramMap.get("STR_error")));
			} // end if
		}

	} // end function ngOnInit


	/**
	 * Function > onSubmit
	 * @desc login a user
	 * @return {void}
	 */
	onSubmit()
	{

		if (this.OBJ_form_group.valid)
		{

			this.OBJ_model = this.OBJ_form_group.getRawValue();
			this.BOO_loading = true;

			this.OBJ_auth_service.authenticate(this.OBJ_model)
			.subscribe
			(
				// login successful
				OBJ_data => {
					this.setClient("/starter");
				},
				// error
				OBJ_error => {

					if (OBJ_error.status == 0 || !OBJ_error.error)
					{
						// output error via alert service
						this.OBJ_alert_service.error(this.OBJ_translate_service.instant("error_default"));
					}
					else if (OBJ_error.error.cst_type && typeof OBJ_error.error.cst_type != "undefined")
					{
						// output error via alert service
						this.OBJ_alert_service.error(this.OBJ_translate_service.instant(OBJ_error.error.cst_type.toLowerCase()));
					}
					else
					{
						// output error via alert service
						this.OBJ_alert_service.error(OBJ_error.error.detail);
					} // end if

					this.BOO_loading = false;

				}
			);

		} // end if

	} // end function onSubmit


	/**
	 * Function > setClient
	 * @param {string} STR_navigate
	 * @return any
	 */
	private setClient(STR_navigate: string = ""): any
	{

		// get current user
		let OBJ_current_user = this.OBJ_helper_service.getFromLocalstorage('current_user');
		let OBJ_client = null;

        // user account ist active?
		if (OBJ_current_user.active)
		{

			OBJ_current_user.clients.forEach((OBJ_item) => {
				let STR_client_url = OBJ_item.webaddress;

				// Non-Production-Environments have slightly different url
				if(ENVIRONMENT.env !== 'production')
				{
					// if www is set (not always the case) delete it
					STR_client_url = STR_client_url.replace('www', '');

					// append environmental subdomain (usually dev or preview)
					STR_client_url = ENVIRONMENT.location.subdomain + (STR_client_url.charAt(0) !== "."?".":"") + STR_client_url;
				} // end if

				if (STR_client_url == window.location.hostname) {
					OBJ_client = OBJ_item;
				} // end if
			});

			// no client configuration for called host
            if (OBJ_client == null) {
                this.OBJ_router.navigate(["/client-selection"]);
			}
            // user has a role
			else if (OBJ_client.roles.length > 0) {
                // fetch navigation and cache it in local storage
                this.OBJ_navigation_service.load(OBJ_client.id, OBJ_client.roles[0].id)
                    .then(OBJ_response => {

                        // set client
                        this.OBJ_helper_service.setInLocalstorage('client', OBJ_client);

                        // navigate
                        if (STR_navigate.length > 0) {
                            this.OBJ_router.navigate([STR_navigate]);
                        } // end if

                    });

			} else {
				// output error via alert service
				this.OBJ_alert_service.error(this.OBJ_translate_service.instant("error_default"));
				this.BOO_loading = false;

				// console error
				this.OBJ_helper_service.error(
					{class: 'AuthComponent', function: 'setClient'},
					"no roles exists",
					OBJ_client,
				);
			} // end if

		}
		else
		{

			// remove items from storage
			this.OBJ_helper_service.removeFromStorage('current_user');
			this.OBJ_helper_service.removeFromStorage('access');

			// output error via alert service
			this.OBJ_alert_service.error(this.OBJ_translate_service.instant("error_account_inactive"));
			this.BOO_loading = false;

		} // end if

		return OBJ_client;

	} // end function setClient


	/**
	 * Function > showPassword
	 * @param {any} OBJ_input
	 * @return {any}
	 */
	showPassword(OBJ_input: any): any
	{
		OBJ_input.type = (OBJ_input.type==="password")?"text":"password";
	} // end class showPassword


} // end class AuthComponent
